import { forwardRef, useContext } from 'react'
import NoneAnchor from 'components/NoneAnchor'
import { FilterContext } from 'features/dashboard/filter/FilterContext'

const FilterAddInput = forwardRef((props, ref) => {
  const { value, setValue, setMenuVisible } = useContext(FilterContext)
  const handleInputChange = ({ target: { value: v } }) => {
    setValue(v)
  }
  const showMenu = () => {
    setMenuVisible(true)
  }
  return (
    <li ref={ref}>
      <div className="box_inptxt">
        <span className="inner_inp">
          <input
            className="inp_txt"
            maxLength={50}
            value={value}
            onChange={handleInputChange}
            onClick={showMenu}
            onFocus={showMenu}
          />
        </span>
        {value.trim() !== '' && (
          <NoneAnchor className="btn_del" onClick={() => setValue('')}>
            <span className="ico_comm ico_del">삭제</span>
          </NoneAnchor>
        )}
      </div>
    </li>
  )
})
FilterAddInput.displayName = 'FilterAddInput'
export default FilterAddInput
